import React, { useEffect, useRef, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./CategoryWiseData.scss";
import categoryImg from "../../img/CategoryImg.svg";
import { Link, useParams } from "react-router-dom";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";

export default function CategoryWiseData({ data }) {
  const [expanded, setExpanded] = useState(false);
  const { name } = useParams();
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // Store selected item data
  const categoryRefs = useRef([]); // Create refs for each category

  // Function to get unique categories from the data
  const getUniqueCategories = (data) => {
    const uniqueCategories = new Set();

    data.forEach((item) => {
      if (item.category) {
        uniqueCategories.add(item.category);
      }
    });

    return Array.from(uniqueCategories);
  };

  const getUniqueCategories123 = (data) => {
    const uniqueCategories = new Map();

    data.forEach((item) => {
      if (item.category) {
        uniqueCategories.set(item.category, item.categoryHeader);
      }
    });

    // Convert the Map to an array of objects with {header: categoryHeader, name: category}
    return Array.from(uniqueCategories, ([category, categoryHeader]) => ({
      header: categoryHeader,
      name: category,
    }));
  };

  const uniqueCategories123 = getUniqueCategories123(data);

  // Generate unique category data
  const uniqueCategories = getUniqueCategories(data);

  // Function to create a valid ID from category name
  const createPanelId = (category) => {
    return category.replace(/\s+/g, "-").toLowerCase(); // Replace spaces with dashes and convert to lowercase
  };

  useEffect(() => {
    if (uniqueCategories.length > 0) {
      setExpanded(createPanelId(uniqueCategories[0])); // Expand the first category
    }
  }, [data]);

  const handleChange = (panel) => (event, isExpanded) => {
    // Toggle the expanded state
    setExpanded((prev) => (prev === panel ? false : panel));
    console.log(
      "Panel:",
      panel,
      "Is Expanded:",
      isExpanded,
      "Current Expanded:",
      expanded
    );
  };

  const handleClickOpen = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  function formatPrice(number) {
    if (number === undefined || number === null || isNaN(number)) {
      return "N/A"; // Default message for invalid values
    }
    return (
      new Intl.NumberFormat("en-KE", { useGrouping: true })
        .format(number)
        .replace(/,/g, " ") + " KES"
    );
  }

  return (
    <div className="mainCategorywiseCls">
      <div className="categoryType">
        {uniqueCategories123 &&
          uniqueCategories123.map((item, index) => {
            const panelId = createPanelId(item.name); // Create the panel ID for each category
            return (
              <div
                onClick={() =>
                  handleChange(panelId)(null, expanded !== panelId)
                } // Use arrow function to pass arguments properly
                key={index}
                className={`item-category ${
                  expanded === panelId ? "active" : ""
                }`}
              >
                <div style={{ display: "grid", gap: "4px" }}>
                  {item.header && (
                    <span style={{ fontSize: "11px", fontWeight: "normal" }}>
                      {item.header}
                    </span>
                  )}
                  <span style={{ fontSize: "12px" }}>
                    {item.name}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
      {uniqueCategories.length > 0 ? (
        uniqueCategories.map((category, index) => {
          const panelId = createPanelId(category); // Generate a unique ID based on the category name

          // Filter items that belong to the current category
          const itemsInCategory = data.filter(
            (item) => item.category === category
          );
          console.log(itemsInCategory);
          return (
            <div ref={(el) => (categoryRefs.current[index] = el)} key={panelId}>
              <Accordion
                key={panelId} // Use the unique panel ID as the key
                expanded={expanded === panelId}
                onChange={handleChange(panelId)} // Call handleChange when clicked
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${panelId}-content`}
                  id={`${panelId}-header`}
                  sx={{
                    border: "2px solid #eee",
                    borderLeft: "none",
                    borderRight: "none",
                    minHeight: "10px !important",
                    maxHeight: "50px !important",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(21, 40, 76, 0.87)",
                      fontWeight: "700",
                      fontSize: "22px",
                    }}
                  >
                    {category}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="DetailsAcc">
                  <div style={{ display: "grid", gap: "3px" }}>
                    {itemsInCategory.map((item, index) => (
                      <>
                        {item.Name !== "" ? (
                          <>
                            <div
                              className="box-category"
                              key={index}
                              onClick={() => handleClickOpen(item)}
                            >
                              <span
                                style={{
                                  backgroundImage: `url(${
                                    item.ImageURL || categoryImg
                                  })`,
                                }}
                                className="img-box"
                              ></span>
                              <div className="detailsBox">
                                <span className="name">{item.Name}</span>
                                <span className="des">{item.dec}</span>

                                {item.category === "Expertly Crafted Pizzas" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <span style={{ display: "grid" }}>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "700",
                                          }}
                                        >
                                          Large
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(item.Large)}
                                        </span>
                                      </span>
                                      <span
                                        style={{
                                          display: "grid",
                                          color: "#15284CDE",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "700",
                                          }}
                                        >
                                          Medium
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(item.Medium)}
                                        </span>
                                      </span>
                                    </div>
                                  </>
                                ) : item.category === "Cakes" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "10px",
                                        // gridTemplateColumns:"30% 30% 30%"
                                        justifyContent:"space-between"
                                      }}
                                    >
                                      <span style={{display:"grid"}}>
                                        {item.Quantity.length !==0  && (
                                          <>
                                            <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {item.type}
                                        </span>
                                          </>
                                        )}
                                      
                                        <span
                                          style={{fontSize:"12px" }}
                                          className="kes"
                                        >
                                          {formatPrice(item.KES)}
                                        </span>
                                      </span>
                                      {item.Quantity.map((q, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            display:"grid"
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              color: "#15284CDE",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {q.Quantity}
                                          </span>
                                          <span style={{fontSize:"12px"}} className="kes">
                                            {formatPrice(q.Price)}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ) : (item.category === "Mocha" || item.category === "House Coffee" || item.category === "Cappuccino" || item.category === "Latte") ? (
                                  <>
                                  {item.Single === 0 ? (
                                      <span className="kes">
                                        {formatPrice(item.KES)}
                                     </span>
                                  ) : (
                                    <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    <span style={{ display: "grid" }}>
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "#15284CDE",
                                          fontWeight: "700",
                                        }}
                                      >
                                        Single
                                      </span>
                                      <span
                                        style={{ paddingTop: "5px" }}
                                        className="kes"
                                      >
                                        {formatPrice(item.Single)}
                                      </span>
                                    </span>
                                    <span
                                      style={{
                                        display: "grid",
                                        color: "#15284CDE",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "#15284CDE",
                                          fontWeight: "700",
                                        }}
                                      >
                                        Double
                                      </span>
                                      <span
                                        style={{ paddingTop: "5px" }}
                                        className="kes"
                                      >
                                        {formatPrice(item.Double)}
                                      </span>
                                    </span>
                                  </div>
                                  )}
                                  
                                  </>
                                )
                                
                                : (
                                  <span className="kes">
                                    {formatPrice(item.KES)}
                                  </span>
                                )
                                
                                }
                              </div>
                            </div>

                            <Divider className="divider-cate" />
                          </>
                        ) : (
                          <div>No items found.</div>
                        )}
                      </>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })
      ) : (
        <Typography>No categories found.</Typography> // Display a message if no categories are found
      )}

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        id="mainPopup"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: "#15284C",
            }}
          >
            <CloseIcon sx={{ fontSize: "18px" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedItem ? (
            <div style={{ display: "grid", gap: "0px" }}>
              <img
                loading="lazy"
                src={selectedItem.RectImageURL || categoryImg}
                alt={selectedItem.Name}
                style={{
                  width: "100%",
                  borderRadius: "20px",
                  height: "190px",
                  objectFit: "cover",
                }}
              />
              <Typography
                component="div"
                className="item-name"
                div
                gutterBottom
              >
                {selectedItem.Name}
              </Typography>

              <Typography component="div" className="item-dec" gutterBottom>
                {selectedItem.dec}
              </Typography>

              <Typography component="div" className="item-kes" gutterBottom>
                {/* {selectedItem.KES} KES */}

                {/* {selectedItem.category === "Pizza" ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "3rem",
                      }}
                    >
                      <span style={{ display: "grid" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#15284CDE",
                            fontWeight: "700",
                          }}
                        >
                          Large
                        </span>
                        <span style={{ paddingTop: "5px" }} className="kes">
                          {formatPrice(selectedItem.Large)}
                        </span>
                      </span>
                      <span style={{ display: "grid" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#15284CDE",
                            fontWeight: "700",
                          }}
                        >
                          Medium
                        </span>
                        <span style={{ paddingTop: "5px" }} className="kes">
                          {formatPrice(selectedItem.Medium)}
                        </span>
                      </span>
                    </div>
                  </>
                ) : (
                  <span className="kes">{formatPrice(selectedItem.KES)}</span>
                )} */}


                            {selectedItem.category === "Expertly Crafted Pizzas" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <span style={{ display: "grid" }}>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "700",
                                          }}
                                        >
                                          Large
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(selectedItem.Large)}
                                        </span>
                                      </span>
                                      <span
                                        style={{
                                          display: "grid",
                                          color: "#15284CDE",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "700",
                                          }}
                                        >
                                          Medium
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(selectedItem.Medium)}
                                        </span>
                                      </span>
                                    </div>
                                  </>
                                ) : selectedItem.category === "Cakes" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        // gridTemplateColumns:"30% 30% 30%",
                                        justifyContent:"flex-start",
                                        gap:"2rem"
                                      }}
                                    >
                                      <span style={{display:"grid"}}>
                                        {selectedItem.Quantity.length !==0  && (
                                          <>
                                            <span
                                          style={{
                                            fontSize: "15px",
                                            color: "#15284CDE",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          {selectedItem.type}
                                        </span>
                                          </>
                                        )}
                                      
                                        <span
                                          style={{fontSize:"15px" }}
                                          className="kes"
                                        >
                                          {formatPrice(selectedItem.KES)}
                                        </span>
                                      </span>
                                      {selectedItem.Quantity.map((q, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            display:"grid"
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "15px",
                                              color: "#15284CDE",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            {q.Quantity}
                                          </span>
                                          <span style={{fontSize:"15px"}} className="kes">
                                            {formatPrice(q.Price)}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )
                                : (selectedItem.category === "Mocha" || selectedItem.category === "House Coffee" || selectedItem.category === "Cappuccino" || selectedItem.category === "Latte" ) ? (
                                  <>
                                  {selectedItem.Single === 0 ? (
                                    <>
                                     <span className="kes">
                                    {formatPrice(selectedItem.KES)}
                                  </span>
                                    </>
                                  ): (
                                    <>
                                     <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <span style={{ display: "grid" }}>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          Single
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(selectedItem.Single)}
                                        </span>
                                      </span>
                                      <span
                                        style={{
                                          display: "grid",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#15284CDE",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          Double
                                        </span>
                                        <span
                                          style={{ paddingTop: "5px" }}
                                          className="kes"
                                        >
                                          {formatPrice(selectedItem.Double)}
                                        </span>
                                      </span>
                                    </div>
                                    </>
                                  )}
                                  
                                  </>
                                )
                                : (
                                  <span className="kes">
                                    {formatPrice(selectedItem.KES)}
                                  </span>
                                )
                                
                                }
              </Typography>

              {selectedItem &&
                selectedItem.Upgrades &&
                selectedItem.Upgrades.length > 0 && (
                  <>
                    <Divider />

                    <Typography
                      component="div"
                      className="item-upgrades"
                      gutterBottom
                    >
                      Upgrades
                    </Typography>

                    {selectedItem.Upgrades.map((item) => {
                      return (
                        <>
                          <div className="Upgrades-items">
                            <span className="Upgrades-name">{item.name}</span>
                            <span
                              className="Upgrades-price"
                              style={{
                                display: "grid",
                                justifyContent: "flex-end",
                              }}
                            >
                              +{item.price}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </>
                )}
            </div>
          ) : (
            <Typography>No details available.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
